import { render, staticRenderFns } from "./InstructorProgress.vue?vue&type=template&id=331c5c60&"
import script from "./InstructorProgress.vue?vue&type=script&lang=js&"
export * from "./InstructorProgress.vue?vue&type=script&lang=js&"
import style0 from "./InstructorProgress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VChip,VIcon,VSlider})
